import { Button, Label, Listbox, ListboxOption, ListboxOptions, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import clsx from 'clsx'
import { Fragment } from 'react'

export type Topic = {
  id: string
  name: string
}

const topics: Topic[] = [
  { id: 'general', name: 'General' },
  { id: 'sales', name: 'Sales' },
  { id: 'support', name: 'Support' },
  { id: 'team-discount', name: 'Discounts for larger teams' },
  { id: 'bulk-server', name: 'Discounts for using Slackpipe on infrastructure' },
  { id: 'feature-request', name: 'Can you add XZY feature?' },
  { id: 'bug-report', name: 'Bug report' },
  {
    id: 'customer-request-integration',
    name: 'Will you add an integration for a service that I use?',
  },
  {
    id: 'service-integration',
    name: 'How can I create an integration for my service?',
  },
]

export function getTopic(id: string) {
  return topics.find((topic) => topic.id === id)
}

export default function ContactUsTopic({
  label = '',
  selected = topics[0],
  onSelect,
}: {
  label?: string
  selected: Topic
  onSelect: (topic: Topic) => void
}) {
  return (
    <Listbox value={selected} onChange={onSelect}>
      {({ open }) => (
        <>
          <Label className="block text-sm font-medium leading-6 text-gray-900">
            Topic
          </Label>
          <div className="relative mt-2">
            <Button className="relative w-full cursor-default rounded-md bg-white py-2 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-600 sm:text-sm sm:leading-6">
              <span className="block truncate">{selected.name}</span>
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <ChevronUpDownIcon
                  className="size-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <ListboxOptions className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {topics.map((topic) => (
                  <ListboxOption
                    key={topic.id}
                    className={({ active }) =>
                      clsx(
                        active ? 'bg-blue-600 text-white' : 'text-gray-900',
                        'relative cursor-default select-none py-2 pl-3 pr-9',
                      )
                    }
                    value={topic}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={clsx(
                            selected ? 'font-semibold' : 'font-normal',
                            'block truncate',
                          )}
                        >
                          {topic.name}
                        </span>

                        {selected ? (
                          <span
                            className={clsx(
                              active ? 'text-white' : 'text-blue-600',
                              'absolute inset-y-0 right-0 flex items-center pr-4',
                            )}
                          >
                            <CheckIcon className="size-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </ListboxOption>
                ))}
              </ListboxOptions>
            </Transition>
          </div>
        </>
      )}
    </Listbox>
  )
}
